function TwoColumnLayout({ children,className }: any): JSX.Element {
  return (
    <div
      className={`grid xs:grid-rows-twoRowLayout md:grid-rows-1 md:grid-cols-twoColumnSettingsTabletPageLayout lg:grid-cols-twoColumnSettingsPageLayout md:h-[calc(100vh_-_177px)] lg:h-[calc(100vh_-_120px)] overflow-auto ${className}`}
    >
      {children}
    </div>
  );
}

export default TwoColumnLayout;
